import styled from '@emotion/styled'
import { Image } from 'app/components/Common/Image'
import React, { memo } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

export interface Props {
  image?: any
  title?: string
  URL?: string
}

export const Hotel = memo(function Hotel({ image, title, URL }: Props) {
  const imageObj = image?.file?.childImageSharp?.gatsbyImageData
  const imageField = imageObj
    ? {
        alt: image?.title || undefined,
        sources: imageObj.images.sources[0].srcSet || undefined,
        src: imageObj.images.fallback.src || undefined,
        srcSet: imageObj.images.fallback.srcSet || undefined,
        width: imageObj.width || undefined,
        height: imageObj.height || undefined,
      }
    : undefined

  return (
    <Container href={URL} rel="noopener" target="_blank">
      <Background>
        {image ? (
          <LazyLoadComponent>
            <Image {...imageField} />
          </LazyLoadComponent>
        ) : null}
      </Background>

      <Title>{title}</Title>
    </Container>
  )
})

const Background = styled.div`
  aspect-ratio: 1.4;
  background: ${({ theme }) => theme.colors.variants.neutralDark2};
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.25s ease-in-out;
  }

  @media (max-width: 1199px) {
    aspect-ratio: 1.5;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.25rem;
  margin-top: 1rem;

  @media (max-width: 1199px) {
    font-size: 0.75rem;
    line-height: 1rem;
    margin-top: 0.5625rem;
  }
`

const Container = styled.a`
  width: 10.278vw;
  margin-left: 1.875rem;
  &:first-of-type {
    margin-left: 0;
  }
  &:hover {
    ${Background} {
      img {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 1199px) {
    width: calc(50% - 1.25rem);
    margin: 1.875rem 1.25rem 0 0;
  }
`
